import { APIResponse } from '../../../../@types/api-response';

export enum TradingFeatureEnum {
  UNSPECIFIED = 'FEATURE_UNSPECIFIED',
  DAY_TRADE = 'FEATURE_DAY_TRADE',
  SPLIT_ORDER = 'FEATURE_SPLIT_ORDER',
}

export interface DebtRatioRules {
  force_sell: number;
  caution: number;
}

export enum EventTypeEnum {
  UNSPECIFIED = 'EVENT_TYPE_UNSPECIFIED',
  OUTSIDE_MARKET_HOURS = 'EVENT_TYPE_DISABLE_OUTSIDE_MARKET_HOURS',
  EXCEED_DEBT_RATIO = 'EVENT_TYPE_DISABLE_EXCEED_DEBT_RATIO',
}

export interface DayTrade {
  countdown_start: number;
  remaining_trading_close: number;
  trading_open: string;
  trading_close: string;
  event_type: EventTypeEnum;
  debt_ratio_rules: DebtRatioRules;
}

export interface SplitOrder {
  remaining_trading_open: number;
  remaining_trading_close: number;
  trading_open: string;
  trading_close: string;
  max_order: number;
}

export type GetTradingInfoResponse = APIResponse<{
  day_trade?: DayTrade;
  split_order?: SplitOrder;
}>;

export interface DayTradeBuyPayload {
  symbol: string;
  price: number;
  shares: string;
  multiplier: number;
  platform_order_type: PlatformOrderType;
}

export interface DayTradeSellPayload {
  symbol: string;
  price: number;
  shares: string;
  platform_order_type: PlatformOrderType;
}

export interface DayTradeAmendPayload {
  orderid: string;
  price: number;
  shares: string;
  multiplier: number;
}

export type BulkTradeAmendPayload = {
  price: number;
  shares: number;
  order_id: string;
}[];

export enum SmartOrderLabel {
  TP = 'TP', // take profit
  SL = 'SL', // stop loss
  MO = 'MO', // market order
  TS = 'TS', // trailing stop,
  AB = 'AB', // auto buy
  BO = 'BO', // bracket order
  LIT_SELL = 'LIT_SELL', // limit if touched sell
  VTO = 'VTO', // volume trigger order
}

export const ORDER_TYPE_VALUE_TEXT = {
  [SmartOrderLabel.TP]: 'Take Profit',
  [SmartOrderLabel.SL]: 'Stop Loss',
  [SmartOrderLabel.TS]: 'Trailing Stop',
  [SmartOrderLabel.AB]: 'Limit If Touched',
  [SmartOrderLabel.LIT_SELL]: 'Limit If Touched',
  [SmartOrderLabel.BO]: 'Bracket Limit Order',
  [SmartOrderLabel.MO]: 'Market Order',
};
